(function() {
    'use strict';
    angular.module('app')
        .controller('BBABillingController', function($scope, $location) {});
})();


// WEBPACK FOOTER //
// ./js/controllers/BBABillingController.js